"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.parse-float.js");

require("core-js/modules/es.parse-int.js");

require("core-js/modules/es.array.sort.js");

require("core-js/modules/es.array.reverse.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.array.includes.js");

require("core-js/modules/es.string.includes.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.search.js");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _EnhancedTableHead = _interopRequireDefault(require("./EnhancedTableHead"));

var _EnhancedTableToolbar = _interopRequireDefault(require("./EnhancedTableToolbar"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function descendingComparator(a, b, orderBy) {
  if (getDataFromObjectField(b, orderBy) < getDataFromObjectField(a, orderBy)) {
    return -1;
  }

  if (getDataFromObjectField(b, orderBy) > getDataFromObjectField(a, orderBy)) {
    return 1;
  }

  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc' ? (a, b) => descendingComparator(a, b, orderBy) : (a, b) => -descendingComparator(a, b, orderBy);
}

function getDataFromObjectField(object, field) {
  // Retrieve the value of the cell (in case the field is a nested object)
  let remainingColumnField = field;
  let value = object;
  let indexOfPeriod = remainingColumnField.indexOf('.');

  while (indexOfPeriod !== -1) {
    // Get the substring and find the value
    let substring = remainingColumnField.substring(0, indexOfPeriod);
    remainingColumnField = remainingColumnField.substring(indexOfPeriod + 1);
    value = value[substring];
    indexOfPeriod = remainingColumnField.indexOf('.');
  }

  return value != null ? value[remainingColumnField] : null;
}

class MaterialTable extends _react.Component {
  constructor(props) {
    var _this$props$options$o, _this$props$options, _this$props$options$o2, _this$props$options2, _this$props$options$p, _this$props$options3, _this$props$options$s, _this$props$options4;

    super(props);

    _defineProperty(this, "retrieveRemoteData", () => {
      if (this.isRemoteData() && !this.state.isLoadingRemoteData) {
        var _columns$orderByIdx;

        this.setState({
          isLoadingRemoteData: true
        });
        const {
          page,
          rowsPerPage,
          order,
          orderByIdx,
          searchTerms
        } = this.state;
        const {
          columns
        } = this.props; // Create where object

        let where = {}; // Column-specific searching

        for (let columnTitle in searchTerms) {
          var _this$props$columns, _this$props$columns$f;

          let columnField = (_this$props$columns = this.props.columns) === null || _this$props$columns === void 0 ? void 0 : (_this$props$columns$f = _this$props$columns.find(column => column.title === columnTitle)) === null || _this$props$columns$f === void 0 ? void 0 : _this$props$columns$f.field;

          if (columnField != null) {
            var _searchTerms$columnTi, _searchTerms$columnTi2;

            // Simple Search Box
            if (((_searchTerms$columnTi = searchTerms[columnTitle]) === null || _searchTerms$columnTi === void 0 ? void 0 : _searchTerms$columnTi.searchType) === 'column') {
              where[columnField] = {
                $like: '%' + searchTerms[columnTitle].searchValue + '%'
              };
            } // Float Range Search Boxes


            if (((_searchTerms$columnTi2 = searchTerms[columnTitle]) === null || _searchTerms$columnTi2 === void 0 ? void 0 : _searchTerms$columnTi2.searchType) === 'range') {
              let searchValue = searchTerms[columnTitle].searchValue;
              let min = (searchValue === null || searchValue === void 0 ? void 0 : searchValue[0]) == null || (searchValue === null || searchValue === void 0 ? void 0 : searchValue[0]) === '' ? null : parseFloat(searchValue === null || searchValue === void 0 ? void 0 : searchValue[0]);
              let max = (searchValue === null || searchValue === void 0 ? void 0 : searchValue[1]) == null || (searchValue === null || searchValue === void 0 ? void 0 : searchValue[1]) === '' ? null : parseFloat(searchValue === null || searchValue === void 0 ? void 0 : searchValue[1]);
              if (min != null) where[columnField] = {
                $gte: min
              };
              if (max != null) where[columnField] = {
                $lte: max
              };
            }
          }
        }

        this.props.data({
          page,
          rowsPerPage,
          order: [[(_columns$orderByIdx = columns[orderByIdx]) === null || _columns$orderByIdx === void 0 ? void 0 : _columns$orderByIdx.field, order]],
          where
        }).then(_ref => {
          let {
            results,
            totalCount
          } = _ref;
          this.setState({
            isLoadingRemoteData: false,
            remoteData: results,
            remoteTotalCount: totalCount
          });
        }).catch(error => {
          console.log(error);
          this.setState({
            isLoadingRemoteData: false
          });
        });
      }
    });

    _defineProperty(this, "handleRequestSort", (_, propertyIdx) => {
      const isAsc = this.state.orderByIdx === propertyIdx && this.state.order === 'asc';
      this.setState({
        order: isAsc ? 'desc' : 'asc',
        orderByIdx: propertyIdx,
        page: 0
      }, () => this.retrieveRemoteData());
    });

    _defineProperty(this, "handleChangePage", (_, newPage) => {
      this.setState({
        page: newPage
      }, () => this.retrieveRemoteData());
    });

    _defineProperty(this, "handleChangeRowsPerPage", e => {
      this.setState({
        rowsPerPage: parseInt(e.target.value, 10),
        page: 0
      }, () => this.retrieveRemoteData());
    });

    _defineProperty(this, "getOrderedData", data => {
      const {
        order,
        orderByIdx
      } = this.state;
      const column = this.props.columns[orderByIdx];
      let sortedData = data.slice(); // Prioritize a custom sort over the default one

      if (column !== null && column !== void 0 && column.customSort) {
        sortedData.sort(column.customSort);
        if (order === 'desc') sortedData.reverse();
      } // Otherwise, return the default sort
      else if (column !== null && column !== void 0 && column.field) {
        sortedData.sort(getComparator(order, column.field));
      }

      return sortedData;
    });

    _defineProperty(this, "getSearchedData", data => {
      // Remote data is searched via the api
      if (this.isRemoteData()) return data;
      const {
        searchTerms,
        searchTerm
      } = this.state;
      let searchedData = data.slice(); // Check if the all filter has been applied

      let allFilterApplied = searchTerm != null && searchTerm !== '';
      return searchedData.filter(row => {
        var _searchTerms$column$t5;

        let inAllFilter = false;
        let inEveryColumnFilter = true;

        for (const column of this.props.columns) {
          var _searchTerms$column$t, _searchTerms$column$t2, _searchTerms$column$t3, _searchTerms$column$t4;

          // Check if this column filter has been applied
          let columnFilterApplied = false;

          if (((_searchTerms$column$t = searchTerms[column.title]) === null || _searchTerms$column$t === void 0 ? void 0 : _searchTerms$column$t.searchType) === 'range' && (((_searchTerms$column$t2 = searchTerms[column.title].searchValue) === null || _searchTerms$column$t2 === void 0 ? void 0 : _searchTerms$column$t2[0]) !== '' || ((_searchTerms$column$t3 = searchTerms[column.title].searchValue) === null || _searchTerms$column$t3 === void 0 ? void 0 : _searchTerms$column$t3[1]) !== '')) {
            columnFilterApplied = true;
          } else if (((_searchTerms$column$t4 = searchTerms[column.title]) === null || _searchTerms$column$t4 === void 0 ? void 0 : _searchTerms$column$t4.searchType) === 'column' && searchTerms[column.title].searchValue !== '') {
            columnFilterApplied = true;
          } // Perform column filter, if applicable


          if (columnFilterApplied) {
            switch ((_searchTerms$column$t5 = searchTerms[column.title]) === null || _searchTerms$column$t5 === void 0 ? void 0 : _searchTerms$column$t5.searchType) {
              case 'range':
                if (!this.getRangeSearch(searchTerms, column, row)) inEveryColumnFilter = false;
                break;

              case 'column':
                if (!this.getColumnSearch(searchTerms, column, row)) inEveryColumnFilter = false;
                break;

              default:
            }
          } // Perform all filter, if applicable


          if (allFilterApplied) {
            // Check custom filter
            if ((column === null || column === void 0 ? void 0 : column.customFilterAndSearch) != null && column !== null && column !== void 0 && column.customFilterAndSearch(searchTerm, row)) inAllFilter = true; // Check field values

            if ((column === null || column === void 0 ? void 0 : column.field) != null) {
              let value = getDataFromObjectField(row, column.field);

              if (value != null) {
                var _value$toString, _value$toString$toLow, _value$toLowerCase;

                // Handle default search for booleans, numbers, and strings
                if (typeof value === 'boolean' && (_value$toString = value.toString()) !== null && _value$toString !== void 0 && (_value$toString$toLow = _value$toString.toLowerCase()) !== null && _value$toString$toLow !== void 0 && _value$toString$toLow.includes(searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.toLowerCase())) inAllFilter = true;else if (typeof value === 'number' && value.toString().includes(searchTerm)) inAllFilter = true;else if (typeof value === 'string' && (_value$toLowerCase = value.toLowerCase()) !== null && _value$toLowerCase !== void 0 && _value$toLowerCase.includes(searchTerm === null || searchTerm === void 0 ? void 0 : searchTerm.toLowerCase())) inAllFilter = true;
              }
            }
          }
        }

        return (allFilterApplied && inAllFilter || !allFilterApplied) && inEveryColumnFilter;
      });
    });

    _defineProperty(this, "getOrderedAndSearchedData", data => {
      return this.getOrderedData(this.getSearchedData(data));
    });

    _defineProperty(this, "isRemoteData", () => {
      return typeof this.props.data === 'function';
    });

    _defineProperty(this, "getArrayData", () => {
      if (this.props.data == null) return []; // Need to retreieve remote data

      if (this.isRemoteData()) {
        return this.state.remoteData;
      }

      return this.props.data;
    });

    _defineProperty(this, "getDisplayRows", data => {
      if (data.length > this.state.rowsPerPage) {
        return data.slice(this.state.page * this.state.rowsPerPage, this.state.page * this.state.rowsPerPage + this.state.rowsPerPage);
      }

      return data;
    });

    this.state = {
      order: (_this$props$options$o = (_this$props$options = this.props.options) === null || _this$props$options === void 0 ? void 0 : _this$props$options.order) !== null && _this$props$options$o !== void 0 ? _this$props$options$o : 'asc',
      orderByIdx: (_this$props$options$o2 = (_this$props$options2 = this.props.options) === null || _this$props$options2 === void 0 ? void 0 : _this$props$options2.orderByIdx) !== null && _this$props$options$o2 !== void 0 ? _this$props$options$o2 : 0,
      page: 0,
      rowsPerPage: (_this$props$options$p = (_this$props$options3 = this.props.options) === null || _this$props$options3 === void 0 ? void 0 : _this$props$options3.pageSize) !== null && _this$props$options$p !== void 0 ? _this$props$options$p : 5,
      searchType: (_this$props$options$s = (_this$props$options4 = this.props.options) === null || _this$props$options4 === void 0 ? void 0 : _this$props$options4.search) !== null && _this$props$options$s !== void 0 ? _this$props$options$s : 'all',
      searchTerms: [],
      searchTerm: '',
      remoteData: [],
      isLoadingRemoteData: false,
      remoteTotalCount: 0
    };
  }

  componentDidMount() {
    this.retrieveRemoteData();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.retrieveRemoteData();
    }
  } // Retrieve remote data asynchronously


  getRangeSearch(searchTerms, column, row) {
    // Prioritize custom search over default
    if (column !== null && column !== void 0 && column.customFilterAndSearch) {
      if (column !== null && column !== void 0 && column.customFilterAndSearch({
        'min': searchTerms[column.title].searchValue[0],
        'max': searchTerms[column.title].searchValue[1]
      }, row)) {
        return true;
      }
    } // Handle default search


    return (searchTerms[column.title].searchValue[0] === '' || parseFloat(searchTerms[column.title].searchValue[0]) <= row[column.field] || searchTerms[column.title].searchValue[0] == null) && (searchTerms[column.title].searchValue[1] === '' || parseFloat(searchTerms[column.title].searchValue[1]) >= row[column.field] || searchTerms[column.title].searchValue[1] == null);
  }

  getColumnSearch(searchTerms, column, row) {
    if (searchTerms[column.title] == null || searchTerms[column.title].searchValue === '') {
      return true;
    } // Prioritize a custom search over the default one
    else if (column !== null && column !== void 0 && column.customFilterAndSearch) {
      var _searchTerms$column$t6;

      if (column !== null && column !== void 0 && column.customFilterAndSearch((_searchTerms$column$t6 = searchTerms[column.title]) === null || _searchTerms$column$t6 === void 0 ? void 0 : _searchTerms$column$t6.searchValue, row)) {
        return true;
      }
    } // Otherwise, return the default search
    else if (column !== null && column !== void 0 && column.field) {
      const value = getDataFromObjectField(row, column.field);

      if (value != null) {
        var _value$toString2, _value$toString2$toLo, _searchTerms$column$t7, _searchTerms$column$t8, _searchTerms$column$t9, _value$toLowerCase2, _searchTerms$column$t10, _searchTerms$column$t11;

        // Handle default search for booleans
        if (typeof value === 'boolean' && (_value$toString2 = value.toString()) !== null && _value$toString2 !== void 0 && (_value$toString2$toLo = _value$toString2.toLowerCase()) !== null && _value$toString2$toLo !== void 0 && _value$toString2$toLo.includes((_searchTerms$column$t7 = searchTerms[column.title]) === null || _searchTerms$column$t7 === void 0 ? void 0 : (_searchTerms$column$t8 = _searchTerms$column$t7.searchValue) === null || _searchTerms$column$t8 === void 0 ? void 0 : _searchTerms$column$t8.toLowerCase())) return true;else if (typeof value === 'number' && value.toString().includes((_searchTerms$column$t9 = searchTerms[column.title]) === null || _searchTerms$column$t9 === void 0 ? void 0 : _searchTerms$column$t9.searchValue)) return true;else if (typeof value === 'string' && (_value$toLowerCase2 = value.toLowerCase()) !== null && _value$toLowerCase2 !== void 0 && _value$toLowerCase2.includes((_searchTerms$column$t10 = searchTerms[column.title]) === null || _searchTerms$column$t10 === void 0 ? void 0 : (_searchTerms$column$t11 = _searchTerms$column$t10.searchValue) === null || _searchTerms$column$t11 === void 0 ? void 0 : _searchTerms$column$t11.toLowerCase())) return true;
      }
    }

    return false;
  } // Manipulate data according to searches/filtering; Called for every display


  render() {
    // Retrieve the list of ordered, searched, and sliced data for this rendering
    let arrayData = this.getArrayData();
    let orderedAndSearchedData = this.getOrderedAndSearchedData(arrayData);
    let displayRows = this.getDisplayRows(orderedAndSearchedData); // Avoid a layout jump when reaching the last page with empty rows.

    const emptyRows = this.state.page > 0 ? this.state.rowsPerPage - displayRows.length : 0;
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      sx: {
        width: '100%'
      }
    }, /*#__PURE__*/_react.default.createElement(_material.Paper, {
      sx: {
        width: '100%',
        mb: 2
      }
    }, /*#__PURE__*/_react.default.createElement(_EnhancedTableToolbar.default, {
      title: this.props.title,
      onSearch: searchTerm => this.setState({
        searchTerm,
        page: 0
      }),
      showSearch: this.state.searchType === 'all' && !this.isRemoteData()
    }), /*#__PURE__*/_react.default.createElement(_material.TableContainer, null, /*#__PURE__*/_react.default.createElement(_material.Table, {
      sx: {
        minWidth: 750
      },
      "aria-labelledby": "tableTitle",
      size: "medium"
    }, /*#__PURE__*/_react.default.createElement(_EnhancedTableHead.default, {
      order: this.state.order,
      orderByIdx: this.state.orderByIdx,
      onRequestSort: this.handleRequestSort,
      columns: this.props.columns,
      searchValues: this.state.searchValues,
      onSearch: searchTerms => this.setState({
        searchTerms,
        page: 0
      }, () => this.retrieveRemoteData()),
      searchType: this.state.searchType
    }), !(this.state.isLoadingRemoteData || this.props.isLoading) ? displayRows.length > 0 ? /*#__PURE__*/_react.default.createElement(_material.TableBody, null, displayRows.map((row, index) => {
      return /*#__PURE__*/_react.default.createElement(_material.TableRow, {
        hover: true,
        key: index
      }, this.props.columns.map((column, columnIdx) => {
        if (column.hidden) return null;
        let value = null; // Prioritize the render function, if provided

        if (column.render) {
          value = column.render(row);
        } // Display the column field otherwise, if provided
        else if (column.field) {
          // Retrieve the value of the cell (in case the field is a nested object)
          value = getDataFromObjectField(row, column.field);
        } // Display boolean values


        if (value === true) value = 'true';else if (value === false) value = 'false';
        return /*#__PURE__*/_react.default.createElement(_material.TableCell, {
          key: columnIdx,
          padding: "normal"
        }, value);
      }));
    }), emptyRows > 0 && /*#__PURE__*/_react.default.createElement(_material.TableRow, {
      style: {
        height: 60 * emptyRows
      }
    }, /*#__PURE__*/_react.default.createElement(_material.TableCell, {
      colSpan: 6
    }))) : /*#__PURE__*/_react.default.createElement(_material.Typography, {
      style: {
        display: 'flex',
        justifyContent: 'left',
        marginLeft: '20px',
        marginTop: '20px',
        width: '100%'
      }
    }, "Nothing to show.") : /*#__PURE__*/_react.default.createElement("div", {
      style: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        paddingTop: '50px'
      }
    }, /*#__PURE__*/_react.default.createElement(_material.CircularProgress, null)))), /*#__PURE__*/_react.default.createElement(_material.TablePagination, {
      rowsPerPageOptions: [5, 10, 20, 100],
      component: "div",
      count: this.isRemoteData() ? this.state.remoteTotalCount : orderedAndSearchedData.length,
      rowsPerPage: this.state.rowsPerPage,
      page: this.state.page,
      onPageChange: this.handleChangePage,
      onRowsPerPageChange: this.handleChangeRowsPerPage
    })));
  }

}

MaterialTable.propTypes = {
  columns: _propTypes.default.array.isRequired,
  data: _propTypes.default.oneOfType([_propTypes.default.array, _propTypes.default.func]).isRequired,
  title: _propTypes.default.any.isRequired,
  isLoading: _propTypes.default.bool.isRequired,
  options: _propTypes.default.object
};
var _default = MaterialTable;
exports.default = _default;